import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Observable, forkJoin, tap } from "rxjs";
import { SegAssignRequest } from "src/app/models/exposureBySeg.model";
import { SEG } from "src/app/models/seg.model";
import { SegService } from "src/app/services/seg.service";
import {
    FormComponent,
    IFormDialogData,
} from "src/app/shared/form/form.component";
import { MultiSelectionFormField } from "src/app/shared/form/formField.model";
import { ILookup } from "src/app/shared/form/lookup.model";
import nameOf from "src/app/shared/form/nameOf.helper";

@Component({
  standalone: false,
    selector: "app-task-group-assignment-dialog",
    templateUrl: "./../../shared/form/form.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./../../shared/form/form.component.scss"],
})
export class TaskGroupAssignmentDialog
    extends FormComponent<SegAssignRequest>
    implements OnInit
{
    segs: ILookup[];
    assignedSegs: SEG[];
    constructor(
        dialogRef: MatDialogRef<TaskGroupAssignmentDialog>,
        private segService: SegService,
        @Inject(MAT_DIALOG_DATA) public data: IFormDialogData,
        protected injector: Injector,
    ) {
        super(dialogRef, null, data, "Task Group Assignment", injector);
    }

    ngOnInit() {
        this.isFormLoading = true;
        forkJoin({
            segs: this.segService.getAll(),
            assignedSegs: this.segService.getAllSegsForTaskGroup(this.data.id),
        }).subscribe(
            (result) => {
                this.entity = this.getNewObject();
                this.assignedSegs = result.assignedSegs;
                this.segs = result.segs;
                this.initModel();
                this.initFields();
                this.isFormLoading = false;
            },
            (error) => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            },
        );
    }

    getNewObject(): SegAssignRequest {
        return new SegAssignRequest();
    }

    initModel(): void {
        this.entity.taskGroupId = this.data.id as string;
        this.entity.segIds = this.assignedSegs.map((x) => x.id);
    }

    validate(): boolean {
        return true;
    }

    onBeforeSave(model: SegAssignRequest): void {}

    initFields() {
        this.fields = [
            new MultiSelectionFormField({
                property: nameOf<SegAssignRequest>((x) => x.segIds),
                name: "SEGs",
                options: this.segs,
            }),
        ];
    }

    saveAction(model: any): Observable<Object> {
        return this.segService.assignTaskGroup(model).pipe(
            tap(() => {
                this.dialogRef.close();
            }),
        );
    }
}
